export default {
  restaurantabout: {
    for: "FOR",
    restaurants: "RESTAURANTS",

    title1: "Source Fresh Ingredients",
    title2: "from",
    highlight: "Trusted Suppliers",

    desc:
      "MAHAL helps restaurants simplify food procurement by connecting them with verified suppliers for daily and bulk sourcing.",

    text:
      "From independent kitchens to multi-branch restaurant chains, MAHAL empowers restaurants with verified suppliers, transparent pricing, and streamlined bulk ordering — all in one unified platform.",

    li1: "Verified & Reliable Suppliers",
    li2: "Transparent Pricing",
    li3: "Daily & Bulk Ordering",
    li4: "On-Time Delivery",

    cta: "Order for Your Restaurant",
  },
};